import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c0d1bf36"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = {
  class: "contact-list",
  style: {"margin-top":"20px"}
}
const _hoisted_3 = { class: "contact-item" }
const _hoisted_4 = { class: "contact-item-title" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "mailto:bariev.ilnarbi@gmail.com",
  class: "contact-item-link"
}, "bariev.ilnarbi@gmail.com", -1))
const _hoisted_6 = { class: "contact-item" }
const _hoisted_7 = { class: "contact-item-title" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://t.me/bariev_ilnar",
  target: "_blank",
  class: "contact-item-link"
}, "@bariev_ilnar", -1))

import CSectionTitle from "@/components/section/CSectionTitle.vue";
import CSectionSubtitle from "@/components/section/CSectionSubtitle.vue";
import CSectionText from "@/components/section/CSectionText.vue";
import CSectionTwoColumn from "@/components/section/CSectionTwoColumn.vue";
import CContactForm from "@/components/contact/CContactForm.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'CContact',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CSectionTwoColumn, { id: "contact" }, {
    right: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(CContactForm)
      ])
    ]),
    left: _withCtx(() => [
      _createVNode(CSectionSubtitle, { style: {"text-align":"left"} }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('contact-title')), 1)
        ]),
        _: 1
      }),
      _createVNode(CSectionTitle, { style: {"text-align":"left"} }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('contact-quote')), 1)
        ]),
        _: 1
      }),
      _createVNode(CSectionText, { style: {"text-align":"left","margin-top":"20px"} }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('contact-description')), 1)
        ]),
        _: 1
      }),
      _createElementVNode("ul", _hoisted_2, [
        _createElementVNode("li", _hoisted_3, [
          _createElementVNode("div", null, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.$t('contact-social-email')), 1),
            _hoisted_5
          ])
        ]),
        _createElementVNode("li", _hoisted_6, [
          _createElementVNode("div", null, [
            _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.$t('contact-social-telegram')), 1),
            _hoisted_8
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})